export const TRANSITIONS = {
  DURATION: 0.5,
  EASE: [0.32, 0.72, 0, 1],
};

export const VELOCITY_THRESHOLD = 0.4;
